import { render, staticRenderFns } from "./MaintenancePeriod.vue?vue&type=template&id=6b123203&scoped=true"
import script from "./MaintenancePeriod.vue?vue&type=script&lang=js"
export * from "./MaintenancePeriod.vue?vue&type=script&lang=js"
import style0 from "./MaintenancePeriod.vue?vue&type=style&index=0&id=6b123203&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b123203",
  null
  
)

export default component.exports